import React, { useRef, useState } from 'react';

const OV = {
  position: 'fixed', inset: 0, zIndex: 1500,
  background: 'rgba(0,0,0,0.85)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  overflow: 'hidden', touchAction: 'none',
};
const BTN = {
  width: 34, height: 34, borderRadius: '50%', border: 'none',
  background: 'rgba(255,255,255,0.15)', color: '#fff', cursor: 'pointer',
  fontSize: '1rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
};

const MIN_SCALE = 1;
const MAX_SCALE = 5;
const clamp = (s) => Math.min(MAX_SCALE, Math.max(MIN_SCALE, s));

/** Lightbox โชว์รูปเต็มจอ ซูมเข้า/ออกได้ (scroll, ปุ่ม +/−, ดับเบิลคลิก) + ลากดูรูปตอนซูมเข้า */
export default function ImageZoomDialog({ src, alt, onClose }) {
  const [scale, setScale] = useState(1);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const drag = useRef({ active: false, startX: 0, startY: 0, posX: 0, posY: 0, moved: false });

  if (!src) return null;

  const reset = () => {
    setScale(1);
    setPos({ x: 0, y: 0 });
  };
  const zoomIn = () => setScale((s) => clamp(s + 0.5));
  const zoomOut = () =>
    setScale((s) => {
      const next = clamp(s - 0.5);
      if (next === MIN_SCALE) setPos({ x: 0, y: 0 });
      return next;
    });

  const handleWheel = (e) => {
    e.preventDefault();
    setScale((s) => {
      const next = clamp(s + (e.deltaY < 0 ? 0.3 : -0.3));
      if (next === MIN_SCALE) setPos({ x: 0, y: 0 });
      return next;
    });
  };

  const onMouseDown = (e) => {
    if (scale <= MIN_SCALE) return;
    drag.current = { active: true, startX: e.clientX, startY: e.clientY, posX: pos.x, posY: pos.y, moved: false };
  };
  const onMouseMove = (e) => {
    if (!drag.current.active) return;
    const dx = e.clientX - drag.current.startX;
    const dy = e.clientY - drag.current.startY;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) drag.current.moved = true;
    setPos({ x: drag.current.posX + dx, y: drag.current.posY + dy });
  };
  const endDrag = () => {
    drag.current.active = false;
  };

  const handleImgClick = (e) => {
    e.stopPropagation();
    if (drag.current.moved) {
      drag.current.moved = false;
      return;
    }
    if (scale <= MIN_SCALE) zoomIn();
  };

  return (
    <div
      style={OV}
      onClick={(e) => {
        // อยู่ซ้อนอยู่ใน modal รายละเอียดการลงเวลา (DayDetailView) — ต้อง stopPropagation
        // ไม่งั้น click จะทะลุไปโดน onClick ของ modal ข้างนอก ปิดพร้อมกันทั้งคู่
        e.stopPropagation();
        onClose();
      }}
      onWheel={handleWheel}
      onMouseMove={onMouseMove}
      onMouseUp={endDrag}
      onMouseLeave={endDrag}
    >
      <img
        src={src}
        alt={alt}
        draggable={false}
        onMouseDown={onMouseDown}
        onClick={handleImgClick}
        onDoubleClick={(e) => {
          e.stopPropagation();
          reset();
        }}
        style={{
          maxWidth: '92vw',
          maxHeight: '88vh',
          transform: `translate(${pos.x}px, ${pos.y}px) scale(${scale})`,
          transition: drag.current.active ? 'none' : 'transform 0.12s ease-out',
          cursor: scale > MIN_SCALE ? 'grab' : 'zoom-in',
          userSelect: 'none',
          borderRadius: 4,
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        }}
      />

      <div
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'absolute', top: 16, right: 16, display: 'flex', gap: 8, alignItems: 'center' }}
      >
        <button style={BTN} onClick={zoomOut} title="ซูมออก">−</button>
        <button
          style={{ ...BTN, width: 'auto', padding: '0 10px', fontSize: '0.72rem', borderRadius: 17 }}
          onClick={reset}
          title="รีเซ็ตซูม"
        >
          {Math.round(scale * 100)}%
        </button>
        <button style={BTN} onClick={zoomIn} title="ซูมเข้า">+</button>
        <button style={{ ...BTN, marginLeft: 8, background: 'rgba(255,255,255,0.25)' }} onClick={onClose} title="ปิด">✕</button>
      </div>
    </div>
  );
}
